import React, { useState, useEffect } from 'react';
import BarChart from 'components/BarChart';
import { Spin, notification, Empty } from 'antd';
import Api from 'config/api';
import { makeStyles } from '@material-ui/styles';

export default function Unemployment() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const classess = useStyles();

  useEffect(() => {
    getUnemployment();
  }, []);

  const getUnemployment = async () => {
    setLoading(true);
    try {
      const response = await Api.get('website/get-unemployment');
      setData(response?.data?.data);
    } catch ({ message, status }) {
      notification.error({
        message: `Status code: ${status}`,
        description: `Failed to load Unemployment Data. ${message}`,
      });
    }
    setLoading(false);
  };

  const requiredData = data.map((data) => {
    return {
      name: data.year,
      value: data.value,
    };
  });

  return (
    <Spin spinning={loading}>
      <div className={classess.container}>
        {data.length > 0 ? (
          <div className={classess.barCharWrap}>
            <BarChart
              data={requiredData.sort((a, b) => a.name - b.name)}
              valueType="percentage"
              isLoading={loading}
              opposite={true}
            />
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '300px' }}
          >
            <Empty />
          </div>
        )}
      </div>
    </Spin>
  );
}

const useStyles = makeStyles({
  container: {
    overflow: 'scroll',
  },
  barCharWrap: {
    minWidth: '935px',
  },
});
